import { type ComponentType } from "react"
import { type IconProps } from "@/ui/icons"
import { formatCompact } from "../../plan-a/economic-data/calculations"
import { ComputeBar } from "./ComputeBar"
import {
  ROW_GRID_TEMPLATE,
  ROW_TRANSITION,
  getHighlightBackground,
} from "./tooltipRowStyle"

// One line of the tooltip on the shared column grid: icon, name, compute
// (number + accent bar). Serves both the bold region summary row (`emphasized`)
// and the dimmer indented per-lab rows.
export const TooltipRow = ({
  Icon,
  label,
  compute,
  barFraction,
  highlighted,
  dimmed,
  indented,
  emphasized,
}: {
  Icon?: ComponentType<IconProps>
  label: string
  compute?: number
  // Compute as a fraction (0–1) of the largest compute shown, sizing the inline
  // bar. Undefined means no bar (e.g. zero/absent compute).
  barFraction?: number
  highlighted: boolean
  dimmed: boolean
  indented?: boolean
  emphasized?: boolean
}) => {
  const fontWeight = highlighted ? (emphasized ? 700 : 500) : 400
  return (
    <div
      className="grid items-center gap-2"
      style={{
        gridTemplateColumns: ROW_GRID_TEMPLATE,
        paddingLeft: indented ? 14 : 4,
        paddingRight: 8,
        paddingBottom: indented ? 3 : 5,
        paddingTop: indented ? 3 : 4,
        marginBottom: 1,
        opacity: dimmed ? 0.7 : 1,
        transition: ROW_TRANSITION,
        fontWeight,
        backgroundColor: getHighlightBackground(highlighted, emphasized),
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 2,
        borderBottomRightRadius: 2,
      }}
    >
      {Icon
        ? <Icon size={11} color="currentColor" style={{ opacity: indented ? 0.65 : 1 }} />
        : <span aria-hidden/>}
      <span
        className="overflow-hidden text-ellipsis whitespace-nowrap leading-tight"
        style={{ fontWeight, minWidth: 0 }}
      >
        {label}
      </span>
      <div className="flex items-center justify-end">
        <span className="tabular-nums whitespace-nowrap font-mono leading-tight">
          {compute !== undefined ? formatCompact(compute) : ""}
        </span>
        {/* {barFraction !== undefined && <ComputeBar fraction={barFraction} />} */}
      </div>
    </div>
  )
}
